import { Box } from '@mui/material';
import { Divider, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { MouseEvent } from 'react';
import { PoolButton } from '@synergy/components-next';
import { ThemeWrapper } from '@synergy/theme-next';
import AddIcon from '@mui/icons-material/AddCircleOutline';

interface PoolAutocompleteListFooterProps {
    url: string;
    text: string;
}
export const PoolAutocompleteListFooter = (props: PoolAutocompleteListFooterProps) => {
    return (
        <ThemeWrapper>
            <Box sx={{ textAlign: 'right' }}>
                <Divider />
                <PoolButton
                    variant="outlined"
                    href={props.url}
                    onMouseDown={(event: MouseEvent<HTMLElement>) => event.preventDefault()}
                    sx={{ padding: theme => theme.spacing(2, 3) }}
                >
                    <Stack gap={1} flexDirection={'row'}>
                        <AddIcon color="primary" />
                        <FormattedMessage id={props.text} />
                    </Stack>
                </PoolButton>
            </Box>
        </ThemeWrapper>
    );
};
